module.exports = __webpack_public_path__ + "static/media/triple-s.662ee403.svg";